<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--project dashboard-widget--project-overview" >
        <div class="card-header">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" aria-hidden="true"><i class="fa-solid fa-chalkboard-user"></i></span>
                <span>{{ $t('Project Overview') }}</span>
            </h6>
        </div>
        <div class="card-body project-overview-widget__body">
            <div
                class="project-overview-widget__scroll"
                role="region"
                aria-label="Project overview metrics"
                tabindex="0"
            >
              <div class="project-overview-widget__metrics text-center">
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Total Sell Contract & Variation') }}</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationSellTotal) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label">{{ $t('Total Budget Contract & Variation') }}</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationBudgetTotal) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Committed Total') }}</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationCommittedTotal) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Uncommitted Total') }}</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationUncommittedTotal) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Contingency') }}</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationContingecyTotal) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Overall Running GP') }} ({{ReformatNumber(contractAndVariationGpPercentage)}}%)</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationGp) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__metric">
                    <div class="project-overview-widget__metric-card">
                        <h6 class="project-overview-widget__label"> {{ $t('Overall Forecast GP') }} ({{ReformatNumber(contractAndVariationGpForecastPercentage)}}%)</h6>
                        <div class="project-overview-widget__value">{{projectInfo.currencyId.sign}}{{ ReformatNumber(contractAndVariationGpForecast) }}</div>
                    </div>
                </div>
                <div class="project-overview-widget__summary">
                    <a :href="dotNetUrl + '/project/overview/'+projectInfo.projectOldId" class="dashboard-widget__link dashboard-widget__link--center"> {{ $t('Show Full Summary') }}</a>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

import 'dotenv/config'
import {DashboardGetProjectOverviewTotals} from '@/actions/projectActions.js'
import {ReformatNumber} from '../../helpers/utilities.js'
export default {
    name : 'ProjectOverviewWidget',
    props : ['projectInfo'],
    data(){
        return {
            dotNetUrl : process.env.VUE_APP_DOTNET_URL,
            totals : {

            },
            ReformatNumber
        }
    },
    computed :{
        contractAndVariationBudgetTotal(){
            return this.totals.contractBudgetTotal + this.totals.variationBudgetTotal
        },
        contractAndVariationCommittedTotal(){
            return this.totals.contractCommitedTotal + this.totals.variationCommitedTotal
        },
        contractAndVariationUncommittedTotal(){
            // return (this.totals.contractBudgetTotal - this.totals.contractCommitedTotal - this.totals.contractTransferedToGp) + (this.totals.variationBudgetTotal - this.totals.variationCommitedTotal - this.totals.variationTransferedToGp)
            return this.totals.uncommittedTotal
        },
        contractAndVariationSellTotal(){
            return this.totals.contractSellTotal + this.totals.variationSellTotal
        },
        contractAndVariationContingecyTotal(){
            // return (this.totals.contractSavings - this.totals.contractTransferedToGp) + (this.totals.variariationSavings + this.totals.variationTransferedToGp)
            return this.totals.contigencyGp
        },
        contractAndVariationGp(){
            return (this.totals.contractTransferedToGp + this.totals.variationTransferedToGp)
        },
        contractAndVariationGpPercentage(){
            return (this.contractAndVariationGp / this.contractAndVariationSellTotal) * 100
        },
        contractAndVariationGpForecast(){
            // return ( this.contractAndVariationSellTotal -  this.contractAndVariationBudgetTotal) + this.contractAndVariationGp
            return this.totals.gpForecast
        },
        contractAndVariationGpForecastPercentage(){
            // return (this.contractAndVariationGpForecast / this.contractAndVariationSellTotal) * 100
            return (this.totals.gpForecast / this.contractAndVariationSellTotal) * 100
        },
    },
    mounted : async function(){
        const self = this
        const response = await DashboardGetProjectOverviewTotals(self.projectInfo._id)
        if(!response)
            return
        self.totals = response.data || {}
    }
}
</script>

<style scoped>
.project-overview-widget__body {
    padding: 1.15rem 1.25rem 1.35rem;
    background:
        linear-gradient(180deg, rgba(234, 247, 241, 0.48) 0%, rgba(255, 255, 255, 0.94) 42%),
        #ffffff;
}

.project-overview-widget__scroll {
    width: 100%;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-color: #8abaaa #edf5f2;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
}

.project-overview-widget__scroll:focus-visible {
    outline: 2px solid #238a67;
    outline-offset: 2px;
}

.project-overview-widget__metrics {
    display: grid;
    grid-template-columns: repeat(7, minmax(8.75rem, 1fr));
    gap: 0.8rem;
    align-items: stretch;
    min-width: 68rem;
    padding-bottom: 0.35rem;
}

.project-overview-widget__metric-card {
    position: relative;
    display: flex;
    min-height: 6.4rem;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.62rem;
    overflow: hidden;
    border: 1px solid #cfe3da;
    border-radius: 0.35rem;
    padding: 1rem 0.85rem;
    background: linear-gradient(180deg, #ffffff 0%, #f8fcfa 100%);
    box-shadow: 0 0.35rem 1rem rgba(24, 79, 62, 0.08);
}

.project-overview-widget__metric-card::before {
    content: "";
    position: absolute;
    inset: 0 0 auto;
    height: 0.22rem;
    background: linear-gradient(90deg, #238a67 0%, #65d7a8 100%);
}

.project-overview-widget__label {
    min-height: 2.1rem;
    margin: 0;
    color: #3f524c;
    font-size: 0.88rem;
    font-weight: 700;
    line-height: 1.25;
}

.project-overview-widget__value {
    color: #1f2f2a;
    font-size: 1.18rem;
    font-weight: 800;
    line-height: 1.1;
    overflow-wrap: anywhere;
}

.project-overview-widget__summary {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    padding-top: 0.05rem;
}

.project-overview-widget__summary :deep(.dashboard-widget__link) {
    min-height: 2.15rem;
    padding-inline: 1rem;
    box-shadow: 0 0.35rem 0.9rem rgba(35, 138, 103, 0.12);
}

@media (max-width: 767.98px) {
    .project-overview-widget__body {
        padding: 0.95rem;
    }

}
</style>
